import { IconButton, HStack, VStack } from '@genial/components';
import { BoxRadius, Color, Spacing } from '@genial/design-tokens';
import React from 'react';

import {
  TableContent,
  TableContentItemColumn,
  TableContentItemText,
} from '../../../../../../components/TableContent';
import { TableContentItemPercentage } from '../../../../../../components/TableContent/percentage';
import { LateralBar } from '../../../../../NewApplication/Product/components/LateralBar';
import { useAddedProductItem } from '../../../../hooks/addedProductItem';
import { AddedProductItemList, AddedProductItemSectionProps } from '../../../../utils/types';
import { ItemSeparator } from '../../../ItemSeparator';
import { AddedProductItem } from '../AddedProductItem';

export const AddedProductItemSection: React.FC<AddedProductItemSectionProps> = ({
  itemData,
  hasPercentage = false,
  navigationType = 'cart',
}) => {
  const { sectionIsOpened, toggleSection, productItemAddTypeData } = useAddedProductItem({
    itemData,
  });

  if (itemData.items.length === 0) {
    return;
  }

  return (
    <VStack space={Spacing['stack.nano']}>
      <TableContent direction="row">
        <LateralBar
          backgroundColor={productItemAddTypeData.backgroundColor}
          borderTopLeftRadius={BoxRadius.sm}
          borderBottomLeftRadius={BoxRadius.sm}
        />
        <TableContentItemColumn space={Spacing['inline.quarck']}>
          <TableContentItemText variant="semibold">Produto</TableContentItemText>
          <HStack alignItems={'center'} space={Spacing['inline.nano']}>
            {hasPercentage && (
              <TableContentItemPercentage>{itemData.percentage}</TableContentItemPercentage>
            )}
            <TableContentItemText>{productItemAddTypeData.title}</TableContentItemText>
          </HStack>
        </TableContentItemColumn>
        <HStack alignItems="center" space={Spacing['inline.sm']}>
          <TableContentItemColumn display={{ base: 'none', sm: 'flex' }}>
            <TableContentItemText variant="semibold">Ativos adicionados</TableContentItemText>
            <TableContentItemText>{itemData.items.length} Ativos</TableContentItemText>
          </TableContentItemColumn>
          <TableContentItemColumn minW="138px" display={{ base: 'none', sm: 'flex' }}>
            <TableContentItemText variant="semibold">Total do Investimento</TableContentItemText>
            <TableContentItemText>{itemData.totalFormatted}</TableContentItemText>
          </TableContentItemColumn>
          <IconButton
            icon={sectionIsOpened ? 'ChevronUp' : 'ChevronDown'}
            testId="open-product-category"
            onPress={toggleSection}
            iconColor={Color['neutral.black']}
          />
        </HStack>
      </TableContent>
      <VStack divider={<ItemSeparator />}>
        {sectionIsOpened &&
          itemData.items.map((data: AddedProductItemList, index: number) => (
            <AddedProductItem
              key={index.toString()}
              navigationType={navigationType}
              offerType={itemData.type}
              data={data}
            />
          ))}
      </VStack>
    </VStack>
  );
};
